import { SwapOutlined } from "@ant-design/icons";

export const camposFormulario = () => {
    return {
        title: "Usuario",
        campos: [
            {
                name: "pokemon",
                label: "Nombre Pokemon",
                type: "text",
            },
            {
                name: "numeroPokedex",
                label: "Número Pokedex",
                type: "number",
            },
            {
                name: "codigo",
                label: "Codigo pokemon",
                type: "text"
            },
            {
                name: "fechaCapturaDesde",
                label: "Fecha Captura Desde",
                type: "date"
            },
        ]
    }
}

export const columns = (moveTab = null) => {

    return [
        {
            title: "Nombre",
            dataIndex: "nombre",
            width: "20%",
        },
        {
            title: "Número Pokedex",
            dataIndex: "numeroDex",
            width: "20%",
        },
        {
            title: "Codigo Pokemon",
            dataIndex: "codigo",
            width: "10%",
        },
        {
            title: "Fecha de Captura",
            dataIndex: "fechaCaptura",
            width: "20%",
        },
    ];
}

export const camposTransferir = (usuarios, idUsuario, idPokemon) => {
    return {
        title: "Transferir",
        campos: [
            {
                name: "idUsuarioOrigen",
                label: "Id del usuario origen",
                type: "number",
                defaultValue: idUsuario,
                disabled: true,
                hidden: true,
            },
            {
                name: "idUsuarioDestino",
                label: "Usuario destino",
                type: "autocomplete",
                opciones: usuarios,
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
            },
        ]
    }
}


export const camposFormularioCrear = (pokemon, codigos, idUsuario, setPokemon) => {
    return {
        title: "Añadir pokémon",
        campos: [
            {
                name: "idUsuario",
                label: "Id del usuario",
                type: "number",
                defaultValue: idUsuario,
                disabled: true,
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
            },
            {
                name: "pokemones",
                label: "Pokémon",
                type: "multiple",
                onChange: (value) => { setPokemon(value) },
                opciones: pokemon,
                rules: [
                    {
                        required: true,
                        message: "Campo requerido",
                    }
                ],
            }
        ]
    }
}
